import { Policy } from '../../../../types/types';
import {
    BASEURL, ENDPOINTS, SPXAPI, getFile,
} from '../../../../api';
import { captureErrorForSentry } from '../../../utils';

// Invoked post-auth only: resolves the file policy via the authenticated
// (Cognito/IAM-signed) file endpoint instead of the public one.
const tryFetchActualPolicy = async (API: SPXAPI, fileId: string, policyId: string | null): Promise<Policy> => {
    let filePolicy: Policy = null;
    let filePolicyId: string = policyId;
    try {
        if (!filePolicyId) {
            const file = await getFile(API, fileId);
            filePolicyId = file.policy_id;
        }
        filePolicy = await API.get(BASEURL.backend(), ENDPOINTS.policy(filePolicyId), {});
    } catch (error) {
        console.log('could not load file policy', error);
        captureErrorForSentry(error, 'SharedFile.tryFetchActualPolicy');
    }
    return filePolicy;
};

export default tryFetchActualPolicy;
